import { Region } from '../utils/commonInterfaces';
import { getRegion } from '../components/regionWrapper';
import { getExportAxiosRequestByRegion } from '../utils/getExportAxiosRequestByRegion';

export const getComponies = () => {
    const region = getRegion();
    const axios = getExportAxiosRequestByRegion(region as Region);
    return async ( _dispatch:any) => {
        try {
            const { data } = await axios(`/companies/locations`, {
                method: 'GET',
            });
            return { payload: data };
        } catch (e) { return { error: true }; }
    };
};